exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logout .dialog__body .header[data-v-9d2910ce] {\n  padding: 1.25rem 3.7rem;\n}\n.logout .dialog__body .header h4[data-v-9d2910ce] {\n  font-size: 0.85rem;\n  color: #333333;\n  line-height: 1.2rem;\n  text-align: center;\n}", ""]);

// exports
